export enum ReportType {
  BNP_HOSPITALITY_APPROVER_REPORT = 'bnphospitality_approver_report',
  BNP_HOSPITALITY_HOST_REPORT = 'bnphospitality_host_report',
}
